import { ESecondaryItemType, SecondaryItem } from "@similarweb/ui-components";

import { ROUTES } from "single-spa/react-app/config/solutions25/adIntelligence/publisherAnalysis/publisherAnalysisConstants";
import { swSettings } from "app/common/services/swSettings";
import { DigitalSuiteGenericNavBarBody } from "app/components/sidebar3/secondary-side-bar/components/DigitalSuiteGenericNavBarBody";
import { DigitalSuiteGenericBarHeader } from "app/components/sidebar3/secondary-side-bar/components/DigitalSuiteGenericNavBarHeader";
import type { ISecondaryBarContents } from "app/components/sidebar3/secondary-side-bar/types/ISecondaryBarContents";
import { BADGE_ITEMS } from "app/components/sidebar3/types";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import { applyNavItemPermissions } from "../../../../../pages/workspace/common/workspacesUtils";
import type { INavItem } from "../../../types";

const hasSearchAndAdsCanary = (): boolean => !!swSettings.components.Home?.resources?.HasSearchAndAdsCanary;

const stateToSidebarTitleMap = {
    [ROUTES.overview]: "ad.intelligence.overview.title",
    [ROUTES.advertisers]: "ad.intelligence.publisher.advertisers.title",
    [ROUTES.ads]: "ad.intelligence.publisher.ads.title",
    // [ROUTES.adNetworks]: "ad.intelligence.publisher.adnetworks.title",
};

export type PANavBarRouteOverrides = {
    overview?: string;
    advertisers?: string;
    ads?: string;
};

export type PublisherAnalysisNavBarOverrides = {
    homeState?: string;
    routeOverrides?: PANavBarRouteOverrides;
};

export const digitalSuitePublisherAnalysisNavBarContent = (
    overrides?: PublisherAnalysisNavBarOverrides,
): ISecondaryBarContents => ({
    SecondaryBarHeader: (
        <DigitalSuiteGenericBarHeader
            state={overrides?.homeState ?? ROUTES.home}
            title={"primary.sidebar.publisher.analysis.title"}
            navBadgeType={BADGE_ITEMS.NEW}
        />
    ),
    SecondaryBarBody: (
        <DigitalSuiteGenericNavBarBody navObj={publisherAnalysisNavObj(overrides?.routeOverrides).navList} />
    ),
});

export const publisherAnalysisNavObj = (overrides?: PANavBarRouteOverrides): { navList: INavItem[] } => {
    const overviewState = overrides?.overview ?? ROUTES.overview;
    const advertisersState = overrides?.advertisers ?? ROUTES.advertisers;
    const adsState = overrides?.ads ?? ROUTES.ads;
    return {
        navList: [
            {
                title: stateToSidebarTitleMap[ROUTES.overview],
                name: "overview",
                state: overviewState,
                itemComponent: SecondaryItem,
                itemType: ESecondaryItemType.Standalone,
                options: {
                    isUSStatesSupported: false,
                    isVirtualSupported: false,
                },
                overrideParams: {
                    webSource: devicesTypes.DESKTOP,
                },
                lockIcon: false,
                hidden: false,
            },
            {
                title: stateToSidebarTitleMap[ROUTES.advertisers],
                name: "advertisers",
                state: advertisersState,
                itemComponent: SecondaryItem,
                itemType: ESecondaryItemType.Standalone,
                options: {
                    isUSStatesSupported: false,
                    isVirtualSupported: false,
                },
                overrideParams: {
                    webSource: devicesTypes.DESKTOP,
                },
                lockIcon: false,
                hidden: false,
            },
            {
                title: stateToSidebarTitleMap[ROUTES.ads],
                name: "ads",
                state: adsState,
                itemComponent: SecondaryItem,
                itemType: ESecondaryItemType.Standalone,
                options: {
                    isUSStatesSupported: false,
                    isVirtualSupported: false,
                },
                overrideParams: {
                    webSource: devicesTypes.TOTAL,
                },
                lockIcon: false,
                hidden: !hasSearchAndAdsCanary(),
            },
            // {
            //     title: stateToSidebarTitleMap[ROUTES.adNetworks],
            //     name: "adnetworks",
            //     state: ROUTES.adNetworks,
            //     itemComponent: SecondaryItem,
            //     itemType: ESecondaryItemType.Standalone,
            //     options: {
            //         isUSStatesSupported: false,
            //         isVirtualSupported: false,
            //     },
            //     overrideParams: {
            //         webSource: devicesTypes.DESKTOP,
            //     },
            //     lockIcon: false,
            //     hidden: false,
            // },
        ].map(applyNavItemPermissions) as INavItem[],
    };
};
